export default {
  id: null,
  descricao: null,
  tipo: 1,
  contas: []
}



// WEBPACK FOOTER //
// ./src/shared/models/access/notificationgroupmodel.js